import React, { useState } from "react";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ComoInput } from "../Common/ComoInput";

interface UserLimitsProps {
  userEvaluationLimit: number;
  userCompanyLimit: number;
  userStorageLimit: number;
  userLibraryLimit: number;
  onChange: (limits: {
    userEvaluationLimit: number;
    userCompanyLimit: number;
    userStorageLimit: number;
    userLibraryLimit: number;
  }) => void;
}

const UserLimits: React.FC<UserLimitsProps> = ({
  userEvaluationLimit,
  userCompanyLimit,
  userStorageLimit,
  userLibraryLimit,
  onChange,
}) => {
  const [tempEvaluationLimit, setTempEvaluationLimit] = useState<
    string | number
  >(userEvaluationLimit);
  const [tempCompanyLimit, setTempCompanyLimit] = useState<string | number>(
    userCompanyLimit,
  );
  const [tempStorageLimit, setTempStorageLimit] = useState<string | number>(
    userStorageLimit,
  );
  const [tempLibraryLimit, setTempLibraryLimit] = useState<string | number>(
    userLibraryLimit,
  );

  const { t } = useTranslation("workspaces");

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;

    if (name === "userEvaluationLimit") {
      setTempEvaluationLimit(value);
    } else if (name === "userCompanyLimit") {
      setTempCompanyLimit(value);
    } else if (name === "userStorageLimit") {
      setTempStorageLimit(value);
    } else if (name === "userLibraryLimit") {
      setTempLibraryLimit(value);
    }
  };

  const handleBlur = () => {
    const newEvaluationLimit =
      tempEvaluationLimit === "" || Number(tempEvaluationLimit) < 1
        ? 1
        : Number(tempEvaluationLimit);

    const newCompanyLimit =
      tempCompanyLimit === "" || Number(tempCompanyLimit) < 1
        ? 1
        : Number(tempCompanyLimit);

    const newStorageLimit =
      tempStorageLimit === "" || Number(tempStorageLimit) < 0
        ? 0
        : Number(tempStorageLimit);

    const newLibraryLimit =
      tempLibraryLimit === "" || Number(tempLibraryLimit) < 0
        ? 0
        : Number(tempLibraryLimit);

    setTempEvaluationLimit(newEvaluationLimit);
    setTempCompanyLimit(newCompanyLimit);
    setTempStorageLimit(newStorageLimit);
    setTempLibraryLimit(newLibraryLimit);

    onChange({
      userEvaluationLimit: newEvaluationLimit,
      userCompanyLimit: newCompanyLimit,
      userStorageLimit: newStorageLimit,
      userLibraryLimit: newLibraryLimit,
    });
  };

  const numberInputSx = {
    "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button": {
      WebkitAppearance: "none",
    },
    "& input[type=number]": {
      MozAppearance: "textfield",
    },
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <ComoInput
          label={t("userEvaluationLimit")}
          name="userEvaluationLimit"
          value={tempEvaluationLimit}
          onChange={handleInputChange}
          onBlur={handleBlur}
          type="number"
          inputProps={{ min: 1, step: 1 }}
          InputLabelProps={{ shrink: true }}
          sx={numberInputSx}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <ComoInput
          label={t("userEntityLimit")}
          name="userCompanyLimit"
          value={tempCompanyLimit}
          onChange={handleInputChange}
          onBlur={handleBlur}
          type="number"
          inputProps={{ min: 1, step: 1 }}
          InputLabelProps={{ shrink: true }}
          sx={numberInputSx}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <ComoInput
          label={t("userStorageLimit")}
          name="userStorageLimit"
          value={tempStorageLimit}
          onChange={handleInputChange}
          onBlur={handleBlur}
          type="number"
          inputProps={{ min: 0, step: 1 }}
          InputLabelProps={{ shrink: true }}
          sx={numberInputSx}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <ComoInput
          label={t("userLibraryLimit")}
          name="userLibraryLimit"
          value={tempLibraryLimit}
          onChange={handleInputChange}
          onBlur={handleBlur}
          type="number"
          inputProps={{ min: 0, step: 1 }}
          InputLabelProps={{ shrink: true }}
          sx={numberInputSx}
        />
      </Grid>
    </Grid>
  );
};

export default UserLimits;
